export default "__VITE_ASSET__WrUewGjV__"